export default __webpack_public_path__ + "static/1702-2880c1012c1905e4687a8a97dd4858f6.gif";